var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "header-section" }, [
    _c(
      "div",
      {
        staticClass: "section-background",
        style: { "background-color": _vm.backgroundColor }
      },
      [
        _c("div", { staticClass: "section-background__effects" }),
        _vm._v(" "),
        _c("div", { staticClass: "section-background__foreground" }, [
          _c("p", { staticClass: "header-section__timestamp" }, [
            _c("span", [_vm._v(_vm._s(_vm.publishDate))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "title-container" },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title"
                  }
                ],
                staticClass: "header-section__title",
                class: { "header-section__title--warning": _vm.hasWarning },
                attrs: {
                  placeholder: "クリックしてタイトルを入力",
                  maxlength: "100"
                },
                domProps: { value: _vm.title },
                on: {
                  keydown: _vm.onKeyDownTitle,
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.title = $event.target.value
                    },
                    _vm.autoResizeTitle
                  ],
                  change: _vm.autoResizeTitle,
                  focus: _vm.onFocusTitle,
                  blur: _vm.onBlurTitle
                }
              }),
              _vm._v(" "),
              _vm.noTitle
                ? _c(
                    "div",
                    {
                      staticClass:
                        "title-container__message title-container__message--warning title-container__message--animated",
                      class: { "title-container__message--focus": _vm.hasFocus }
                    },
                    [
                      _vm._v(
                        "\n          記事のタイトルを入力してください\n        "
                      )
                    ]
                  )
                : _vm.hasInvalidLength
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "title-container__message title-container__message--warning title-container__message--animated",
                        class: {
                          "title-container__message--focus": _vm.hasFocus
                        }
                      },
                      [
                        _vm._v(
                          "\n          タイトルは " +
                            _vm._s(_vm.maxLength) +
                            "文字以内で入力してください（推奨は" +
                            _vm._s(_vm.recommendedLength) +
                            "文字以下です）\n        "
                        )
                      ]
                    )
                  : _vm.hasAlertLength
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "title-container__message title-container__message--info",
                          class: {
                            "title-container__message--focus": _vm.hasFocus
                          }
                        },
                        [
                          _c("p", { staticClass: "message-paragraph" }, [
                            _vm._v(
                              "タイトルは" +
                                _vm._s(_vm.recommendedLength) +
                                "文字以内にすることをお勧めします"
                            )
                          ]),
                          _vm._v(" "),
                          _vm.hasFocus
                            ? _c("p", { staticClass: "message-paragraph" }, [
                                _vm._v(
                                  "\n            ここで指定したタイトルは検索結果のページで表示される内容です。"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n            省略されてしまわないよう、" +
                                    _vm._s(_vm.recommendedLength) +
                                    "文字以下で指定してください。\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
              _vm._v(" "),
              _c("transition", { attrs: { name: "counter-transition" } }, [
                _vm.hasFocus
                  ? _c("div", { staticClass: "title-container__counter" }, [
                      _c(
                        "span",
                        {
                          staticClass: "current-title-length",
                          class: {
                            "current-title-length--warning": _vm.hasAlertLength
                          }
                        },
                        [_vm._v(_vm._s(_vm.title.length))]
                      ),
                      _vm._v("\n            / 50\n          ")
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "section-menu" }, [
      _c("div", { staticClass: "section-buttons" }, [
        _c(
          "div",
          {
            staticClass:
              "section-buttons__button section-buttons__button--colorPicker tooltip-edit-background",
            on: { click: _vm.clickedColorPickerIcon }
          },
          [
            _c("span", { staticClass: "colorPickerIcon fi-paint-bucket" }),
            _vm._v(" "),
            _c("el-color-picker", {
              directives: [
                {
                  name: "click-document",
                  rawName: "v-click-document",
                  value: _vm.closeColorPicker,
                  expression: "closeColorPicker"
                }
              ],
              staticClass: "colorPicker",
              attrs: {
                size: "small",
                "color-format": "rgb",
                predefine: _vm.predefineColors
              },
              on: { change: _vm.submitColor, "active-change": _vm.activeColor },
              model: {
                value: _vm.backgroundColor,
                callback: function($$v) {
                  _vm.backgroundColor = $$v
                },
                expression: "backgroundColor"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }